import { render, staticRenderFns } from "./Skiplinks.vue?vue&type=template&id=37c339be&scoped=true&"
import script from "./Skiplinks.vue?vue&type=script&lang=js&"
export * from "./Skiplinks.vue?vue&type=script&lang=js&"
import style0 from "./Skiplinks.vue?vue&type=style&index=0&id=37c339be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c339be",
  null
  
)

/* custom blocks */
import block0 from "./Skiplinks.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports